/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilLineIcon24Solid = forwardRef('ToolPencilLineIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.004 17.761v2.735a.5.5 0 0 0 .5.5H5.24a1.5 1.5 0 0 0 1.06-.44l9.965-9.963-3.856-3.857L2.444 16.7a1.5 1.5 0 0 0-.44 1.061Z" }),
        React.createElement("path", { d: "m19.405 7.451-1.757 1.757-3.856-3.856 1.757-1.757a1.75 1.75 0 0 1 2.475 0l1.381 1.381a1.75 1.75 0 0 1 0 2.475Z" }),
        React.createElement("path", { d: "M11.5 19a1 1 0 1 0 0 2H22a1 1 0 0 0 0-2H11.5Z" })));
});
